/* eslint react/prop-types: 0 */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import { persistStore, autoRehydrate } from 'redux-persist';
import { asyncSessionStorage } from 'redux-persist/storages';

import { compose, createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { Header, Footer } from 'marketing-components';

// Component, Route, and Lib
import { routeDidUpdate } from './actions/actions-router';
import { chatBotEligibleCheck } from './actions/action-chat-bot';
import Page from '../lib/page';

import largeScreenRoutes from './routes/LargeScreenRoutes';
import rootReducer from './reducers/index';
import HelpApp from './components/HelpApp';
import getHistory from '../lib/HistoryHelper';

const middlewares = [
  thunkMiddleware,
];

if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line  global-require
  const createLogger = require('redux-logger');
  middlewares.push(createLogger());
}

const isLoggedIn = Page.isLoggedIn();

const store = createStore(rootReducer,
  undefined,
  compose(autoRehydrate(),
    applyMiddleware(...middlewares)),
);

persistStore(store, {
  storage: asyncSessionStorage,
  whitelist: ['chatBotFAQ'],
});

// Todo: below `basename` should be updated to `US`.
const history = getHistory();
const isDesktopLayout = Page.isDesktopLayout();
const isChatBotEligible = Page.getIsChatBotEligible();
const isHomePage = Page.isHomePage();
const countryCode = Page.getCountry();

window.histTest = history;

const currentLocation = history.location;

store.dispatch(routeDidUpdate(currentLocation));

// TODO: wire to acrtions-router after backend code

history.listen((location) => {
  store.dispatch(routeDidUpdate(location));
});

if (isDesktopLayout && isLoggedIn && isChatBotEligible && isHomePage) {
  store.dispatch(chatBotEligibleCheck());
}
const routeConfig = largeScreenRoutes; // Using CSS to control left side display logic

function getMppHeaderComponent() {
  if (!isLoggedIn && window.mppContent) {
    const { contentLoggedOut, config } = window.mppContent.header.content;
    const props = { content: contentLoggedOut, config };
    // Overriding header config to have the header menu as drop down for consistency
    props.config.version = 'v1';
    return <Header {...props} />;
  }
  return null;
}

function getMppFooterComponent() {
  if (!isLoggedIn && window.mppContent) {
    const { content } = window.mppContent.footer.content;
    const props = { content };
    // Passing country code to props to render the flag in footer
    props.localeCountry = countryCode === 'uk' ? 'GB' : countryCode.toUpperCase();
    return <Footer {...props} />;
  }
  return null;
}

ReactDOM.render(
  <div>
    { getMppHeaderComponent() }
    <Provider store={store}>
      <Router history={history}>
        <HelpApp sideBar={routeConfig.sideBar} mainContainer={routeConfig.mainContainer} />
      </Router>
    </Provider>
    { getMppFooterComponent() }
  </div>,
  document.querySelector('.smarthelp-react-app'),
);
